export default {"src":"/_next/static/media/orange-circle.68293377.svg","height":48,"width":48};